// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3DKsI","label":"Labeled_label__wwS7C","divider":"Labeled_divider__23tv4"};